module.exports = __webpack_public_path__ + "img/story-3.9c51db05.jpg";